import { createValidations, Validation, ValidationHandler } from './validator';

export type CustomValidation<T> = (handler: (value: T) => boolean | Promise<boolean>, message: string, id?: string) => Validation<T>;

export const createCustom =
  <T>(chain: ValidationHandler<T>[]) =>
  (handler: (value: T) => boolean | Promise<boolean>, message: string, id?: string) =>
    createValidations<T>([...chain, async (value) => [{ valid: await handler(value), message, id }]]);
